import React from 'react';
import { DiscountModal } from './discount-modal';
import { ReplaceProductDrawer } from './replace-product';
import { SelectPriceListDrawer } from './pricelist-drawer/select-price-list-drawer';
import { SelectUOMDrawer } from './select-uom-drawer/select-uom-drawer';
import {
  AddLineItems,
  DiscountType,
  OrderDataLine,
  OrderDataSummary,
  OrderLine,
  ProductVariant,
  UOM,
} from '@zonofi/zono-money-store';
import { OrderDiscountLevel } from '../../constants';
import { SuccessModal } from '../../components';
import { ConfirmModal } from './confrim-modal';
import { LocationModal } from '../../modals';
import { CancelModal } from './cancel-modal';

interface ModalBaseProps {
  open: boolean;
  onClose: () => void;
}

interface OrderDetailsModalGroupProps {
  discount?: ModalBaseProps & {
    onApply: (
      line: OrderDataLine,
      discountType: DiscountType,
      discount: number,
      orderDiscountType: OrderDiscountLevel
    ) => void;
    data: OrderDataLine;
    orderDiscountType: OrderDiscountLevel;
    orderSummary?: OrderDataSummary;
    orderLevelDiscount?: {
      discount: number;
      discountType: string;
    };
    isOrderSummary?: boolean;
  };
  replaceProduct?: ModalBaseProps & {
    lineItems?: AddLineItems[];
    onReplaceProduct?: (product: ProductVariant) => void;
  };
  pricelist?: ModalBaseProps & {
    onSelectPricelist: (pricelistId: string, pricelistName: string) => void;
  };
  uom?: ModalBaseProps & {
    onUomChange: (uom: UOM) => void;
    currentLine?: OrderLine;
  };
  comfirm?: ModalBaseProps & {
    heading: string;
    description: string;
    onConfirmPress: () => void;
    isLoading?: boolean;
  };
  success?: ModalBaseProps & {
    message: string;
    description?: string;
    mainText: string;
    showShareButton?: boolean;
    onMainTextPress?: () => void;
  };
  location?: ModalBaseProps & {
    posCords: {
      latitude: number;
      longitude: number;
    };
    onLocationSelected?: (location: string) => void;
  };
  cancel?: ModalBaseProps & {
    isLoading: boolean;
    onCancelPress: () => void;
  };
}

export const OrderDetailsModalGroup: React.FC<OrderDetailsModalGroupProps> = ({
  discount,
  replaceProduct,
  pricelist,
  uom,
  comfirm,
  success,
  location,
  cancel,
}) => {
  return (
    <>
      {discount && <DiscountModal {...discount} />}
      {replaceProduct && <ReplaceProductDrawer {...replaceProduct} />}
      {pricelist && (
        <SelectPriceListDrawer
          isOpen={pricelist.open}
          onClose={pricelist.onClose}
          onSelectPricelist={pricelist.onSelectPricelist}
        />
      )}
      {uom && <SelectUOMDrawer {...uom} />}
      {success && (
        <SuccessModal
          {...success}
          mainText={success.mainText}
          onMainTextPress={success.onMainTextPress}
        />
      )}
      {comfirm && <ConfirmModal {...comfirm} />}
      {location && <LocationModal {...location} />}
      {cancel && <CancelModal {...cancel} />}
    </>
  );
};
